const PREFIX = 'rk-paper-page-';

/** Stable resume id: prefer YYYY-MM-DD / YYYY-MM over localized labels. */
export function paperResumeKey(resumeId) {
  if (!resumeId) return null;
  return `${PREFIX}${String(resumeId)}`;
}

export function loadPaperPage(resumeId) {
  const key = paperResumeKey(resumeId);
  if (!key) return 0;
  try {
    const n = parseInt(localStorage.getItem(key), 10);
    return Number.isFinite(n) && n >= 0 ? n : 0;
  } catch {
    return 0;
  }
}

export function savePaperPage(resumeId, pageIndex) {
  const key = paperResumeKey(resumeId);
  if (!key || pageIndex < 0) return;
  try {
    localStorage.setItem(key, String(pageIndex));
  } catch {
    /* ignore */
  }
}
